module.exports = __webpack_public_path__ + "static/media/AssinaParalimpiadasSporTV_P.76e5063a.png";